import { render, staticRenderFns } from "./UserLoginHist.vue?vue&type=template&id=c28fee38&scoped=true&"
import script from "./UserLoginHist.vue?vue&type=script&lang=js&"
export * from "./UserLoginHist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28fee38",
  null
  
)

export default component.exports